var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.787,
    height: 8.811,
    viewBox: "0 0 14.787 8.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M9.546,0H1.027A1.028,1.028,0,0,0,0,1.027V7.784A1.028,1.028,0,0,0,1.027,8.811h8.52a1.028,1.028,0,0,0,1.027-1.027V1.027A1.028,1.028,0,0,0,9.546,0Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M328.906,36.7l3.529,1.927V31.981l-3.529,1.927Zm0,0",
    transform: "translate(-317.648 -30.887)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocamera);
export default __webpack_public_path__ + "static/media/videocamera.787e0496.svg";
export { ForwardRef as ReactComponent };